import { Checkbox, Space } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { H3, SecondaryText } from 'components/new-ui/base/typography/styles';
import { SectionContainer } from '../styles';

type Props = {
    checked: boolean;
    onChange: (e: CheckboxChangeEvent) => void;
};

const AEP5AuthorisationSection = ({ checked, onChange }: Props) => {
    return (
        <SectionContainer>
            <Space size={6}>
                <FileTextOutlined style={{ color: 'var(--brand-6)', fontSize: 20 }} />
                <H3>AEP5 Authorisation</H3>
            </Space>

            <SecondaryText style={{ marginTop: 4 }}>
                Confirm you are authorised to use the party's TAN account before uploading AEP5 document.
            </SecondaryText>

            <Checkbox checked={checked} onChange={onChange} style={{ marginTop: 16 }}>
                I confirm I'm verified to use the party's TAN
            </Checkbox>
        </SectionContainer>
    );
};

export default AEP5AuthorisationSection;
